import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { bimCompleteStructureFormationGql } from '../../bimWorkOrderQueries';

const requestId = 'bimCompleteStructureFormation';

export const useBimCompleteStructureFormation = (workOrderId?: number) => {
    const dispatch = useDispatch();

    const [
        bimCompleteStructureFormationData,
        bimCompleteStructureFormationStatus,
        bimCompleteStructureFormationError,
        bimCompleteStructureFormationRequest,
    ] = useRequest({
        requestId,
        query: bimCompleteStructureFormationGql,
        withEffect: false,
    });

    const [bimCompleteStructureFormationReset] = useResetStoreData({ requestId });

    const bimCompleteStructureFormationMakeRequest = useCallback(() => {
        dispatch(bimCompleteStructureFormationRequest({ workOrderId }));
    }, [bimCompleteStructureFormationRequest, dispatch, workOrderId]);

    return {
        bimCompleteStructureFormationReset,
        bimCompleteStructureFormationData,
        bimCompleteStructureFormationStatus,
        bimCompleteStructureFormationError,
        bimCompleteStructureFormationMakeRequest,
    };
};
